import useAxios from "@hooks/useFetch";
import { useCallback } from "react";
import { downloadFileFromBlobResponse } from "@core/utils/file";
import { toast } from "react-toastify";

export function useExport(url: string, payload: any) {
    const { isLoading, doFetch } = useAxios({
        url,
        method: 'post',
        lazy: true,
        payload,
        initialConfig: {
            responseType: 'blob',
        }
    });
    const get = useCallback(
        async () => {
            return doFetch()
                .then((response => {
                    downloadFileFromBlobResponse(response as any).then(() => {
                        toast.success('Exported successfully');
                    });
                }))
                .catch((error) => {
                    console.error('Export error:', error);
                    toast.error('Export failed');
                });
        },
        [doFetch]
    );

    return {
        isLoading,
        get,
    };
}